<ion-header class="ion-no-border" mode="md">
  <ion-toolbar>
    <ion-title>{{ 'window_energy_ratings' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="agreement-content">
    <div class="notice-text" [innerHTML]="textKey | translate"></div>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <div class="ion-padding">
    <ion-item lines="none" class="checkbox-item" (click)="toggleAccepted()">
      <ion-checkbox slot="start" [(ngModel)]="accepted" (click)="$event.stopPropagation()"></ion-checkbox>
      <ion-label>{{ checkboxKey | translate }}</ion-label>
    </ion-item>

    <ion-button expand="block" [disabled]="!accepted" (click)="continue()">
      {{ 'accept' | translate }}
    </ion-button>
  </div>
</ion-footer>